import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { notification, Typography} from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { assignVoucher } from "../../../controllers/V1/winnersControllers";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import { faCheckCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { list as getSubAdminUsers } from "../../../controllers/subAdmin/subAdminControllers";
const AssignWinningVoucherPopup = ({ popUpOpen, togglePopUp, voucher_no }) => {
  const handleCancel = () =>  {
    setAssignType('single');
    setVoucherData([]);
    togglePopUp();
  }

  const [isLoading, setIsLoading] = useState(false);
  const [assignType, setAssignType] = useState('single');
  const [subAdminUsers, setSubAdminUsers] = useState([]);
  const [voucherData, setVoucherData] = useState(voucher_no || []);

  const handleAssignVoucher = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      let vouchers = [];
      if(voucher_no && voucher_no.length > 0){
        vouchers = voucher_no;
      } else if(assignType === "single"){
        vouchers.push(parseInt(formData.get('voucher_no')));
      } else {
        vouchers = voucherData.map(item => parseInt(item.voucher_no));
      }
      if(!formData.get('assigned_to')){
        notification.open({
          message: "Oops!",
          description: `Please select sub-admin account.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 2,
        });
      }
      if(vouchers.length === 0){
        notification.open({
          message: "Oops!",
          description: `Voucher number is required.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 2,
        });
      } 

      if(vouchers?.length > 0){
        const option = {
          user_id : formData.get('assigned_to'),
          vouchers : vouchers
        }
        const res = await assignVoucher(option);
        if(res.status === true){
          notification.open({
            message: "Success!",
            description: res?.message || `Voucher assigned successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle}/>,
            duration: 2,
          });
        } else{
          notification.open({
            message: "Oops!",
            description: res?.message || `Something went wrong. please try again.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
            duration: 2,
          });
        }
      }

    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Something went wrong. please try again.`,
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
        duration: 2,
      });
    } finally {
      setIsLoading(false);
      handleCancel();
    }
  }

  const getSubAdminUsersList = async () => {
    try {
      const option = {
        condition : {
          status : 'A',
          admin_type : 'Sub Admin'
        },
        sort: { _id: -1 },
        lime: 1000,
      }
      const res = await getSubAdminUsers(option);
      setSubAdminUsers(res.result);
    } catch (error) {
      console.log(error);
    }
  }
  
  useEffect(() => { 
    getSubAdminUsersList();
  }, []);


  const handleChangeFile = (e) => {
    try {
      setIsLoading(true);
      const file = e.target.files[0];
      
      if (!file) {
        return;
      }

      // Validate file type
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                      file.type === 'application/vnd.ms-excel' ||
                      file.name.endsWith('.xlsx') ||
                      file.name.endsWith('.xls');
      
      if (!isExcel) {
        notification.open({
          message: "Oops!",
          description: "Please upload a valid Excel file (.xlsx or .xls)",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 2,
        });
        e.target.value = null; // Reset file input
        return;
      }

      // Read file using FileReader
      const reader = new FileReader();
      
      reader.onload = (event) => {
        try {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(sheet);
          
          if (json.length === 0) {
            notification.open({
              message: "Oops!",
              description: "The Excel file is empty or has no valid data.",
              placement: "topRight",
              icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
              duration: 2,
            });
            e.target.value = null; // Reset file input
            return;
          }
          
          setVoucherData(json);
          
        } catch (parseError) {
          console.error('Error parsing Excel:', parseError);
          notification.open({
            message: "Oops!",
            description: "Failed to parse Excel file. Please check the file format.",
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
            duration: 2,
          });
          e.target.value = null; // Reset file input
        }
      };

      reader.onerror = (error) => {
        console.error('FileReader error:', error);
        notification.open({
          message: "Oops!",
          description: "Failed to read the file. Please try again.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 2,
        });
        e.target.value = null; // Reset file input
      };

      // Read the file as ArrayBuffer
      reader.readAsArrayBuffer(file);
      
    } catch (error) {
      console.error('Error in handleChangeFile:', error);
      notification.open({
        message: "Oops!",
        description: "Something went wrong. Please try again.",
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
        duration: 2,
      });
      if (e.target) {
        e.target.value = null; // Reset file input
      }
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Assign Winning Voucher
            </Typography>
            <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}><FontAwesomeIcon icon={faTimesCircle}/></Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
          </Typography>
         
          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <form onSubmit={handleAssignVoucher}>
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="inventory_open_popup_action_btn">
                        <button style={{width: "150px"}} type="button" disabled={voucher_no.length > 0 ? true : false} className={assignType === "single" ? "btn btn-dark" : "btn btn-light categories_cancel_button"} onClick={()=>setAssignType('single')}> Single </button>
                        <button style={{width: "150px"}} type="button" disabled={voucher_no.length > 0 ? true : false} className={assignType === "multiple" ? "btn btn-dark" : "btn btn-light categories_cancel_button"} onClick={()=>setAssignType('multiple')}> Multiple </button>
                      </div>
                    </div>
                  </div>
                  
                  <div className="form-group row">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                      <label for="assigned_to" className="all_lable_for_vendor_dashbaord" > Assigned to : </label>
                      <select
                        name="assigned_to"
                        id="assigned_to"
                        className="form-control categories_select_tg_enter_product"
                      >
                        <option value={""} selected disabled> Select Sub-Admin Account </option>
                        { subAdminUsers && subAdminUsers.length > 0 && subAdminUsers.map((item) => (
                          <option value={item._id} key={item._id}> {`${item.admin_first_name} ${item.admin_last_name}`} </option>
                        ))}
                      </select>
                    </div>

                    {assignType === "single" && (
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <label for="voucher_no" className="all_lable_for_vendor_dashbaord" > Voucher No : </label>
                      <input type="number" name="voucher_no" id="voucher_no" disabled={voucher_no.length > 0 ? true : false} placeholder="Enter voucher number" className="form-control categories_select_tg_enter_product" />
                    </div>
                    )}

                    {assignType === "multiple" && (
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <label for="voucher_file" className="all_lable_for_vendor_dashbaord" > File : </label>
                        <input type="file" name="voucher_file" id="voucher_file" onChange={handleChangeFile} className="form-control categories_select_tg_enter_product" />
                        <Link to="/templates/assign_vouchers_template.xlsx" className="all_lable_for_vendor_dashbaord" target="__blank">* Download Sample File</Link>
                      </div>
                    )}
                    
                    {voucher_no?.length > 0 && (
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <h4 style={{color: "blue"}}>{`${voucher_no?.length} Vouchers Nos. is selected for assignment.`}</h4>
                      </div>
                    )}

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="inventory_open_popup_action_btn">
                        <button style={{width: "150px"}} type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} > Cancel </button>
                        <button style={{width: "150px"}} type="submit" className="btn btn-danger" > Submit </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Typography>
        </div>
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default AssignWinningVoucherPopup;
